export default "__VITE_ASSET__Bvb5j_$v__"